import classnames from 'classnames/bind'
import { ALERT_CODES } from '~/@types/alert'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import {
  CreateCustomerAddressForm,
  UpdateCustomerAddressForm,
} from '@unlikelystudio/react-ecommerce-hooks'

import FormTemplate from '~/components/Abstracts/FormTemplate'
import { AddressCardProps } from '~/components/Account/Logged/AddressBook/AdressItem'
import RichText, { RichTextBlock } from '~/components/UI/RichText'

import { usePopIn } from '~/providers/PopInProvider'
import { useStyle } from '~/providers/StyleProvider'

import useCustomerErrors from '~/hooks/account/useCustomerErrors'
import useAlerts from '~/hooks/useAlerts'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type AddressFormProps = {
  className?: string
  title?: RichTextBlock
  update?: boolean
  address?: Omit<AddressCardProps, 'update'>
}

function AddressForm({ className, title, update, address }: AddressFormProps) {
  const { removeCurrent } = usePopIn()
  const onError = useCustomerErrors()
  const triggerAlert = useAlerts()

  const titleStyle = useStyle({
    color: GlobalThemeColors.Black,
    textPreset: GlobalTextPreset.Title24SangBleuLight,
  })

  const handleSuccess = () => {
    removeCurrent()
    triggerAlert(ALERT_CODES.ENTITY_SAVED)
  }

  const mutationOptions = {
    onSuccess: handleSuccess,
    onError: (error) => {
      const { errsGlobals, errsFields } = onError(error)
      const errors = Object.values(errsGlobals)

      if (errors?.length) {
        errors.map(triggerAlert)
      }

      if (!errors?.length && !Object.values(errsFields)?.length) {
        triggerAlert()
      }
    },
  }

  return (
    <div className={cx(css.AddressForm, className)}>
      <RichText className={cx(css.title, titleStyle)} render={title} />
      <FormTemplate className={css.form}>
        {update ? (
          <UpdateCustomerAddressForm
            addressId={address?.id}
            mutationOptions={mutationOptions}
          />
        ) : (
          <CreateCustomerAddressForm mutationOptions={mutationOptions} />
        )}
      </FormTemplate>
    </div>
  )
}

AddressForm.defaultProps = {}

export default AddressForm
